import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { DefaultTimer, NegativeMinTime, HideTimerBlock, HideTimerSlider } from '../../components/examples/controls-examples';
import { DefaultTimerAPI } from '../../components/api';
export const _frontmatter = {
  "Title": "Default timer"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "default-timer"
    }}>{`Default timer`}</h1>
    <DefaultTimer mdxType="DefaultTimer" />
    <p><em parentName="p">{`The default timer`}</em></p>
    <p>{`The following `}<inlineCode parentName="p">{`Model`}</inlineCode>{` props affect the behavior of the `}<inlineCode parentName="p">{`Timer`}</inlineCode>{`:`}</p>
    <DefaultTimerAPI mdxType="DefaultTimerAPI" />
    <NegativeMinTime mdxType="NegativeMinTime" />
    <p><em parentName="p">{`Timer with negative minTime`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model minTime={-10} maxTime={0} />
`}</code></pre>
    <HideTimerSlider mdxType="HideTimerSlider" />
    <p><em parentName="p">{`Timer with showTimeSlider set to false`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model showTimeSlider={false} />
`}</code></pre>
    <HideTimerBlock mdxType="HideTimerBlock" />
    <p><em parentName="p">{`Timer with showTime set to false`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model showTime={false} />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      